import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  USERS_ADMIN_REPORT,
  USERS_BRAND,
  USERS_DETAIL_USER,
  USERS_DIGITAL_SIGNATURE,
  USERS_ECOMMERCE,
  USERS_EDIT,
  USERS_NEW,
  USERS_OTHER_PASSWORD,
  USERS_OWN_PASSWORD,
  USERS_PASSWORD_POLICY,
  USERS_REGISTER_USER,
  USERS_SEARCH,
  USERS_SEARCH_OPERATIONS,
  USERS_WHITELIST,
} from '@app/@core/constants/routes.constants';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { UsersGuard } from './users.guard';

const routes: Routes = [
  {
    path: USERS_DETAIL_USER,
    loadChildren: () => import('./detail/detail.module').then((m) => m.DetailModule),
    data: { title: marker('Detalle de usuario') }, //TODO: What is this module name?
    canActivate: [UsersGuard],
  },
  {
    path: USERS_NEW,
    loadChildren: () => import('./create/create.module').then((m) => m.CreateModule),
    data: { title: marker('sidenav.menu.users.new') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_EDIT,
    loadChildren: () => import('./edit/edit.module').then((m) => m.EditModule),
    data: { title: marker('Modificar usuario') }, //TODO: What is this module name?
    canActivate: [UsersGuard],
  },
  {
    path: USERS_WHITELIST,
    loadChildren: () => import('./whitelist/whitelist.module').then((m) => m.WhitelistModule),
    data: { title: marker('sidenav.menu.users.whitelist') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_BRAND,
    loadChildren: () => import('./brand/brand.module').then((m) => m.BrandModule),
    data: { title: marker('sidenav.menu.users.brand') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_ECOMMERCE,
    loadChildren: () => import('./ecommerce/ecommerce.module').then((m) => m.EcommerceModule),
    data: { title: marker('sidenav.menu.users.ecommerce') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_ADMIN_REPORT,
    loadChildren: () => import('./adminReport/adminReport.module').then((m) => m.AdminReportModule),
    data: { title: marker('sidenav.menu.users.adminReport') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_PASSWORD_POLICY,
    loadChildren: () => import('./passwordPolicy/passwordPolicy.module').then((m) => m.PasswordPolicyModule),
    data: { title: marker('sidenav.menu.users.passwordPolicy') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_DIGITAL_SIGNATURE,
    loadChildren: () => import('./digitalSignature/digitalSignature.module').then((m) => m.DigitalSignatureModule),
    data: { title: marker('sidenav.menu.users.digitalSignature') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_REGISTER_USER,
    loadChildren: () => import('./register-web-user/register-web-user.module').then((m) => m.RegisterWebUserModule),
    data: { title: marker('sidenav.menu.users.registerWebUser') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_SEARCH,
    loadChildren: () => import('./search/search.module').then((m) => m.SearchModule),
    data: { title: marker('sidenav.menu.users.search') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_OWN_PASSWORD,
    loadChildren: () => import('./own-password/own-password.module').then((m) => m.OwnPasswordModule),
    data: { title: marker('sidenav.menu.users.ownPassword') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_OTHER_PASSWORD,
    loadChildren: () => import('./other-password/other-password.module').then((m) => m.OtherPasswordModule),
    data: { title: marker('sidenav.menu.users.password') },
    canActivate: [UsersGuard],
  },
  {
    path: USERS_SEARCH_OPERATIONS,
    loadChildren: () => import('./operation-search/operation-search.module').then((m) => m.OperationSearchModule),
    data: { title: marker('sidenav.menu.users.operationSearch') },
    canActivate: [UsersGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
